var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4,9h3.5c0.736,0,1.393,0.391,1.851,1.001c0.325-0.604,0.729-1.163,1.191-1.662C9.739,7.516,8.676,7,7.5,7H4   C3.447,7,3,7.448,3,8S3.447,9,4,9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.685,12.111C12.236,10.454,13.941,9,15.334,9h1.838l-1.293,1.293c-0.391,0.391-0.391,1.023,0,1.414   C16.074,11.902,16.33,12,16.586,12s0.512-0.098,0.707-0.293L21,8l-3.707-3.707c-0.391-0.391-1.023-0.391-1.414,0   s-0.391,1.023,0,1.414L17.172,7h-1.838c-2.274,0-4.711,1.967-5.547,4.479l-0.472,1.411C8.674,14.816,7.243,16,6.5,16H4   c-0.553,0-1,0.448-1,1s0.447,1,1,1h2.5c1.837,0,3.863-1.925,4.713-4.479L11.685,12.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.879,13.293c-0.391,0.391-0.391,1.023,0,1.414L17.172,16h-2.338c-1.268,0-2.33-0.891-2.691-2.108   c-0.256,0.75-0.627,1.499-1.09,2.185C11.939,17.239,13.296,18,14.834,18h2.338l-1.293,1.293c-0.391,0.391-0.391,1.023,0,1.414   C16.074,20.902,16.33,21,16.586,21s0.512-0.098,0.707-0.293L21,17l-3.707-3.707C16.902,12.902,16.27,12.902,15.879,13.293z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.599497540bdf593181a991fb6a3921e9.svg";
export { ForwardRef as ReactComponent };